import type { DesignType } from "./types";

export function designTypeMatchesQuery(
  type: DesignType,
  normalizedQuery: string,
): boolean {
  return type.name.toLowerCase().includes(normalizedQuery);
}

export function normalizeSearchQuery(query: string): string {
  return query.trim().toLowerCase();
}
